import * as stylex from '@stylexjs/stylex'
import { colors } from '../tokens/colors.stylex'

export const dcsColors = {
  primary50: '#FFFCF5',
  primary100: '#FDF5E6',
  primary200: '#FFECBF',
  primary300: '#FFDC96',
  primary400: '#FFC96D',
  primary500: '#FFB444',
  primary600: '#FF9E1B',
  primary700: '#D27811',
  primary800: '#A65709',
  primary900: '#793A03',

  secondary50: '#FCF8F6',
  secondary100: '#FFF2E8',
  secondary200: '#F4D9C7',
  secondary300: '#EAC0A8',
  secondary400: '#DFA78C',
  secondary500: '#D58F71',
  secondary600: '#CA7658',
  secondary700: '#AB5338',
  secondary800: '#8B341E',
  secondary900: '#6C1C0C',

  tertiary50: '#F7F6F6',
  tertiary100: '#D7D3D0',
  tertiary200: '#D7D3D0',
  tertiary300: '#D5D3D1',
  tertiary400: '#988C80',
  tertiary500: '#766B61',
  tertiary600: '#544A43',
  tertiary700: '#AB5338',
  tertiary800: '#AB5338',
  tertiary900: '#6C1C0C',
}

export const colorTheme = stylex.createTheme(colors, dcsColors)
